module.exports = __webpack_public_path__ + "media/assets/images/logo_cba-f0e58e18c78b1c20f9e2384bc0c6ae46.png";